export const SET_ONBOARDING_CONFIG = 'TESTANIA/SET_ONBOARDING_CONFIG';
export const SET_TESTANIA_NAME = 'TESTANIA/SET_TESTANIA_NAME';

export const SET_TESTANIA_LOGIN_STATUS = 'TESTANIA/SET_TESTANIA_LOGIN_STATUS';
export const SET_COMPLETE_OBS = 'TESTANIA/SET_COMPLETE_OBS';
export const SET_CURRENT_BRANCH_NAME = 'TESTANIA/SET_CURRENT_BRANCH_NAME';
export const SET_FLOW_LINK = 'TESTANIA/SET_FLOW_LINK';
export const CLEAR_COMPLETE_OBS = 'TESTANIA/CLEAR_COMPLETE_OBS';
